import React, { useEffect, useState } from "react";
import candySheet from "./CANDIES.webp";
const CandySprite = ({ x, y, width, height, displayWidth, className = "" }) => {
	const scale = displayWidth / width;
	const displayHeight = height * scale;

	return (
		<>
			<div
				className={`candy-sprite ${className}`}
				style={{
					width: `${displayWidth}px`,
					height: `${displayHeight}px`,
				}}
			>
				<img
					src={candySheet}
					alt=""
					draggable="false"
					style={{
						width: `${1536 * scale}px`,
						height: `${1024 * scale}px`,
						left: `${-x * scale}px`,
						top: `${-y * scale}px`,
					}}
				/>
			</div>
		</>
	);
};

const CandyLoadingPage = ({
	text = "Preparing your sweet adventure...",
	onLoadingComplete,
}) => {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 100) {
					clearInterval(interval);
					return 100;
				}

				return prev + 1;
			});
		}, 30);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (progress >= 100) {
			onLoadingComplete?.();
		}
	}, [progress, onLoadingComplete]);

	return (
		<div className="candy-loading-page">
			<div className="candy-loading-glow" />

			<CandySprite
				x={26}
				y={25}
				width={305}
				height={396}
				displayWidth={150}
				className="candy-decoration candy-1"
			/>

			<CandySprite
				x={350}
				y={32}
				width={284}
				height={389}
				displayWidth={130}
				className="candy-decoration candy-2"
			/>

			<CandySprite
				x={652}
				y={30}
				width={230}
				height={427}
				displayWidth={100}
				className="candy-decoration candy-3"
			/>

			<CandySprite
				x={890}
				y={50}
				width={179}
				height={410}
				displayWidth={85}
				className="candy-decoration candy-4"
			/>

			<CandySprite
				x={663}
				y={474}
				width={255}
				height={246}
				displayWidth={110}
				className="candy-decoration candy-5"
			/>

			<CandySprite
				x={1173}
				y={530}
				width={184}
				height={188}
				displayWidth={80}
				className="candy-decoration candy-6"
			/>

			<main className="candy-loading-content">
				<div className="candy-loader">
					<div className="candy-loader-glow" />

					<div className="candy-loader-candy">
						<CandySprite
							x={26}
							y={25}
							width={305}
							height={396}
							displayWidth={115}
						/>
					</div>

					<div className="loader-orbit loader-orbit-1" />
					<div className="loader-orbit loader-orbit-2" />
				</div>

				<div className="candy-loading-title">LOADING</div>

				<p className="candy-loading-text">{text}</p>

				<div className="candy-progress-wrapper">
					<div className="candy-progress-track">
						<div
							className="candy-progress-fill"
							style={{
								width: `${progress}%`,
							}}
						>
							<div className="candy-progress-shine" />
						</div>
					</div>

					{/* <span className="candy-progress-number">{Math.round(progress)}%</span> */}
				</div>
			</main>

			<div className="candy-bottom-light" />
		</div>
	);
};

export default CandyLoadingPage;
